// CHANGE (2026-08-14): Behörigheten begärs inte längre vid appstart. Frågan
// ställs i stället i ett meningsfullt sammanhang (efter första avslutade
// spelet, se YatzyGame) – webbläsare auto-nekar allt oftare prompts utan
// användargest, och ett nej där är permanent.
const REMINDER_PROMPT_KEY = 'yatzy-reminder-prompted';

/** Ska vi fråga användaren om notispåminnelser? Endast en gång, och bara om
 *  webbläsaren varken beviljat eller nekat sedan tidigare. */
export function shouldPromptForReminders(): boolean {
  if (!('Notification' in window)) return false;
  if (Notification.permission !== 'default') return false;
  try { return localStorage.getItem(REMINDER_PROMPT_KEY) !== 'true'; } catch { return false; }
}

export function markReminderPromptShown(): void {
  try { localStorage.setItem(REMINDER_PROMPT_KEY, 'true'); } catch {}
}

export async function ensureNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const perm = await Notification.requestPermission();
  return perm === 'granted';
}

export function showAchievementNotification(title: string, body: string, icon?: string) {
  if (!('serviceWorker' in navigator)) return;
  if (Notification.permission !== 'granted') return;
  navigator.serviceWorker.getRegistration().then(reg => {
    if (reg) {
      reg.showNotification(title, {
        body,
        icon: icon || '/logo192.png',
        badge: '/logo192.png',
        tag: 'achievement',
        data: { url: '/' }
      });
    }
  });
}

export function showSimpleNotification(title: string, body: string, tag?: string) {
  if (!('serviceWorker' in navigator)) return;
  if (Notification.permission !== 'granted') return;
  navigator.serviceWorker.getRegistration().then(reg => {
    reg?.showNotification(title, {
      body,
      icon: '/logo192.png',
      badge: '/logo192.png',
      tag,
      data: { url: '/' }
    });
  });
}

export function markPlayedToday(): void {
  try {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem('yatzy-last-played-utc', today);
  } catch {}
}

export function hasPlayedToday(): boolean {
  try {
    const today = new Date().toISOString().slice(0, 10);
    const last = localStorage.getItem('yatzy-last-played-utc');
    return last === today;
  } catch {
    return false;
  }
}

export function scheduleDailyReminders(): void {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  // Prevent scheduling multiple times per session
  if ((window as any).__yatzyRemindersScheduled) return;
  (window as any).__yatzyRemindersScheduled = true;
  // If user hasn't played today, nudge after a short delay
  if (!hasPlayedToday()) {
    setTimeout(() => {
      showSimpleNotification('Dagens Yatzy? 🎲', 'Du har inte spelat än idag. Dagens utmaning väntar! 🏆', 'nudge-today');
    }, 15000);
  }
  // Light challenge prompt a bit later
  setTimeout(() => {
    const challenges = [
      'Klarar du 3 stegar idag? 🔥',
      'Sikta på bonus i övre sektionen! 💪',
      'Slå din bästa totalscore! 🏅',
      'Kan du få Yatzy på under 10 kast? ✨'
    ];
    const msg = challenges[Math.floor(Math.random() * challenges.length)];
    showSimpleNotification('Utmaning för idag', msg, 'challenge');
  }, 60000);
}
